module.exports = __webpack_public_path__ + "static/media/c2.93f834ba.png";